import { ChangeEvent, useState } from "react";
import { Input } from "@newsela/angelou";

import { ICitationAuthor } from "../../../CitationAction.interface";

import {
  formRowCss,
  inputFirstLastNameCss,
  inputMiddleNameCss,
  inputSuffixCss,
} from "./CitationEditFormAuthor.style";

interface CitationEditFormAuthorProps {
  author: ICitationAuthor;
  index: number;
  touched: boolean;
  handleAuthorReturn: (author: ICitationAuthor, index: number) => void;
}

const CitationEditFormAuthor = ({
  author,
  index,
  touched,
  handleAuthorReturn,
}: CitationEditFormAuthorProps) => {
  const [authorValue, setAuthorValue] = useState<ICitationAuthor>(author);

  const handleInputChanges = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    const updatedValues = { ...authorValue, [name]: value };
    setAuthorValue(updatedValues);

    handleAuthorReturn((author = updatedValues), index);
  };

  return (
    <div css={formRowCss}>
      <Input
        label="First name"
        name="firstName"
        isRequired
        inputType={Input.inputTypes.text}
        underInputId="contributors-first-name"
        value={authorValue.firstName || ""}
        onChange={(e) => handleInputChanges(e)}
        touched={touched}
        error={
          !authorValue.firstName || authorValue.firstName?.length === 0
            ? "Missing"
            : null
        }
        __cssFor={inputFirstLastNameCss}
      />
      <Input
        label="Middle name"
        name="middleName"
        isRequired={false}
        inputType={Input.inputTypes.text}
        value={authorValue.middleName || ""}
        onChange={(e) => handleInputChanges(e)}
        underInputId="contributors-middle-name"
        __cssFor={inputMiddleNameCss}
      />
      <Input
        label="Last name"
        name="lastName"
        isRequired
        inputType={Input.inputTypes.text}
        value={authorValue.lastName || ""}
        onChange={(e) => handleInputChanges(e)}
        underInputId="contributors-last-name"
        touched={touched}
        error={
          !authorValue.lastName || authorValue.lastName?.length === 0
            ? "Missing"
            : null
        }
        __cssFor={inputFirstLastNameCss}
      />
      <Input
        label="Suffix"
        name="suffix"
        isRequired={false}
        inputType={Input.inputTypes.text}
        value={authorValue.suffix || ""}
        onChange={(e) => handleInputChanges(e)}
        underInputId="contributors-suffix"
        __cssFor={inputSuffixCss}
      />
    </div>
  );
};

export default CitationEditFormAuthor;
